export default __webpack_public_path__ + "static/person-501b6088cb8a6b0c628cb0307d6c5802.png";